import MarkdownIt from 'markdown-it'

import { getSiteURL, joinURLPath } from '@sigma-frontend-libs/commons'
import { PAYMENTS_METHODS } from '@sigma-legacy-libs/essentials/lib/constants'

import { proxy } from '@/utils'

import render from './render'

const md = new MarkdownIt({
  html: true,
  linkify: true,
  typographer: true
})
md.linkify.set({ fuzzyLink: true })

export default {
  name: 'PaymentsOffer',

  mixins: [ proxy({ defaultValue: true }) ],

  props: {
    method: {
      type: String,
      validator: value => {
        return PAYMENTS_METHODS.includes(value)
      }
    }
  },

  data() {
    return {
      html: undefined,

      showDialog: false,
      loading: false
    }
  },

  watch: {
    method() {
      this.getDocument()
      this.proxy = true
    }
  },

  mounted() {
    this.getDocument()
  },

  methods: {
    async getDocument() {
      this.html = undefined
      if ([ PAYMENTS_METHODS.mandarin, PAYMENTS_METHODS.stripe ].includes(this.method)) {
        return
      }
      if (this.method) {
        this.loading = true
        const pathToFile = joinURLPath('docs', this.locale, 'misc', `${this.method}-payment-offer.md`)
        const response = await fetch(getSiteURL(pathToFile), { cache: 'no-cache' })
        if (!response.ok) {
          throw new Error(response.status)
        }
        this.html = md.render(await response.text())
        this.proxy = true
        this.loading = false
      }
    }
  },

  render
}
